import { BrowserRouter as Router } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./App.css";
import Home from "./pages/Home";
import LoadingPage from "./pages/LoadingPage";

const App = () => {
  const [loading, setloading] = useState(true);

  useEffect(() => {
    setTimeout(() => setloading(false), 6000);
  }, []);

  return (
    <div className="App bg-gray-800">
      <Router>{!loading ? <Home /> : <LoadingPage />}</Router>
    </div>
  );
};

export default App;
